<!-- part2学习动力 -->
<template>
    <!-- 认知，情感，行为倾向，学习动力... 等 -->
    <div class="main_box main_box_part2">
        <!--		<P class="main_title"><span class="block"></span>{{normObj.name}}</P>-->
        <P class="main_title">{{index}}、{{normObj.name}}</P>
        <div class="main_norm_box">
            <div class="norm_box" :style="{width: normObj.score/200*692  + 'px'}" >
                <div class="norm_score">
                    <p class="score">{{normObj.score | toFixed(1)}}</p>
                </div>
                <div class="norm_block norm_block_part2" :style="{left: normDataDongli[normObj.type].l_norm/200*692 + 'px', width: (normDataDongli[normObj.type].r_norm-normDataDongli[normObj.type].l_norm)/200*692 + 'px' }" :title="normDataDongli[normObj.type].l_norm + '~' + normDataDongli[normObj.type].r_norm"></div>
            </div>
        </div>
        <p class="main_detail">
            你在{{normObj.name}}的水平值为
            <span class="color3">{{normObj.score | toFixed(1)}}</span>分，常模范围为
            <span class="color3" v-if="normObj.type=='qinggan'">{{normDataDongli.qinggan.l_norm}}~{{normDataDongli.qinggan.r_norm}}分。</span>
            <span class="color3" v-if="normObj.type=='renzhi'">{{normDataDongli.renzhi.l_norm}}~{{normDataDongli.renzhi.r_norm}}分。</span>
            <span class="color3" v-if="normObj.type=='xingwei'">{{normDataDongli.xingwei.l_norm}}~{{normDataDongli.xingwei.r_norm}}分。</span>
        </p>
        <P class="main_directions">{{comment}}</P>
    </div>
</template>
<script>
export default {
    name: 'page_part2_main',
    components: {  },
    props: {
        index: {},
        normDataDongli: {},
        normObj: {
            type: Object,//norm数组的其中一项
            // required: true
        },
        comment: {
            type: String,//comment的类型解读
            // required: true
        }
    },
    data() {
        return {
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
    },
    methods: {

    }
}
</script>
<style type="text/css" lang='less' scoped>
@import './report.less';
.main_box_part2 {

}
</style>
